import { NextPage } from 'next';
import { getUser } from 'common/api/user';
import ErrorBoundary from '../../components/ErrorBoundary';
import ErrorPage from '../../containers/ErrorPage';
import Travel from '../../containers/Travel';
import config from '../../config';
import { getOrCreateStore } from '../../stores';
import { WavetrakContext } from '../../types/wavetrak';

const TravelPage: NextPage = (props: any) => {
  const {
    page: { payloadStatus },
  } = props;

  const pageContent = () => {
    if (payloadStatus !== 200) {
      return <ErrorPage statusCode={payloadStatus} />;
    }
    return <Travel {...props} />;
  };

  return (
    <ErrorBoundary error={payloadStatus === 500} errorBoundaryId="travel-page">
      {pageContent()}
    </ErrorBoundary>
  );
};

TravelPage.getInitialProps = async (context: WavetrakContext) => {
  const isServer = !!context.req;
  const user = await getUser(context, isServer);
  const store = getOrCreateStore();

  const url = `${config.servicesURL}/travel/landing`;
  const result = await fetch(url);
  const res = await result.json();
  const {
    data,
    status: { statusCode },
  } = res;

  if (isServer) {
    return {
      enableTheme: true,
      enableCssBaseline: true,
      ssrReduxState: store.getState(),
      page: {
        payloadStatus: statusCode,
        travelLandingPage: data,
      },
      user,
    };
  }

  return {
    enableTheme: true,
    enableCssBaseline: true,
    page: {
      payloadStatus: statusCode,
      travelLandingPage: data,
    },
    user,
  };
};

export default TravelPage;
